import { PastTournaments } from "./PastTournaments";
import { UpcomingTournament } from "./UpcomingTournament";
import { LiveTournament } from "./LiveTournament";
import { TournamentTimeline } from "@portal-frontend-ssr/blast-data-api";
import { AdaptiveLink } from "@portal-frontend-ssr/ui";

export const RlTournamentTimeline = ({ data }: { data: TournamentTimeline }) => {
  const allTournamentsLink = "/rl/tournaments";

  const isAnyTournamentLive = data.live.length > 0;

  return (
    <nav className="flex flex-col justify-center gap-4">
      {data.live.length > 0 && (
        <>
          <div className="flex flex-row justify-between">
            <span className="text-white font-style-heading-h4">Ongoing</span>
            <AdaptiveLink to={allTournamentsLink} className="text-primary-100 font-style-label-l3">
              ALL
            </AdaptiveLink>
          </div>
          {data.live.map((tournament) => (
            <LiveTournament gameId="rl" tournament={tournament} key={tournament.id} />
          ))}
        </>
      )}
      {data.upcoming.length > 0 && (
        <>
          <div className="flex flex-row justify-between">
            <span className="text-white font-style-heading-h4">Upcoming</span>
            {data.live.length === 0 && (
              <AdaptiveLink to={allTournamentsLink} className="text-primary-100 font-style-label-l3">
                ALL
              </AdaptiveLink>
            )}
          </div>
          {data.upcoming.slice(0, 2).map((tournament) => (
            <UpcomingTournament gameId={"rl"} tournament={tournament} key={tournament.id} />
          ))}
        </>
      )}
      {data.past.length > 0 && (
        <>
          <div className="flex flex-row justify-between">
            <span className="text-white font-style-heading-h4">Finished</span>
            {data.live.length === 0 && data.upcoming.length === 0 && (
              <AdaptiveLink to={allTournamentsLink} className="text-primary-100 font-style-label-l3">
                ALL
              </AdaptiveLink>
            )}
          </div>
          {data.past.slice(0, isAnyTournamentLive ? 1 : 2).map((tournament) => (
            <PastTournaments gameId={"rl"} tournament={tournament} key={tournament.id} />
          ))}
        </>
      )}
    </nav>
  );
};
